import "@/App.css";
import { ReactLenis } from "lenis/react";
import { ThemeProvider } from "@/theme/ThemeProvider";
import { Navbar } from "@/components/site/Navbar";
import { Hero } from "@/components/site/Hero";
import { Marquee } from "@/components/site/Marquee";
import { Services } from "@/components/site/Services";
import { Manifesto } from "@/components/site/Manifesto";
import { PaidConsult } from "@/components/site/PaidConsult";
import { Portfolio } from "@/components/site/Portfolio";
import { Founder } from "@/components/site/Founder";
import { Testimonials } from "@/components/site/Testimonials";
import { InstaFeed } from "@/components/site/InstaFeed";
import { Contact } from "@/components/site/Contact";
import { BrandsStrip } from "@/components/site/BrandsStrip";
import { WhatsAppFloat } from "@/components/site/WhatsAppFloat";
import { ThemeSwitcher } from "@/components/site/ThemeSwitcher";
import { BookCallProvider } from "@/components/site/BookCall";

function App() {
  return (
    <ThemeProvider>
      <BookCallProvider>
      <ReactLenis root options={{ lerp: 0.08, smoothWheel: true }}>
        <div className="App relative bg-[hsl(var(--bg))] font-body text-[hsl(var(--fg))]">
          <div className="grain" aria-hidden />
          <Navbar />
          <main>
            <Hero />
            <Marquee />
            <Services />
            <Manifesto />
            <PaidConsult />
            <BrandsStrip />
            <Portfolio />
            <Founder />
            <Testimonials />
            <InstaFeed />
            <Contact />
          </main>
          <ThemeSwitcher />
          <WhatsAppFloat />
        </div>
      </ReactLenis>
      </BookCallProvider>
    </ThemeProvider>
  );
}

export default App;
